/**袋迪猜拳*/

import http from '@/utils/http-v4'
import config from '@/config/config'

const api = {
    getGameResult : `${config.apiv4Root}/inner4/ilisten/lottery/auth`,
    getGameVideoResult: `${config.apiv4Root}/inner4/ilisten/lottery/auth:video`,
    getGametimes : `${config.apiv4Root}/inner4/ilisten/lottery/num`
}

/**
 * 音频 袋迪请客接口
 * @param {string} audioId 要授权的音频id 多个用英文逗号隔开
 * @param {string} chapterId 要授权的章节id 多个用英文逗号隔开
 * @param {string} lotteryId 
 * @returns 
 */
export async function getGameResult(audioId,chapterId,lotteryId) {
    return http.post(api.getGameResult,{
    audio_ids: audioId,
    chapter_ids: chapterId,
    lottery_id: lotteryId
    })
}

/**
 * 视频 袋迪请客接口
 * @param {string} videoId 要授权的视频id 多个用英文逗号隔开
 * @param {string} chapterId 要授权的章节id 多个用英文逗号隔开
 * @param {string} lotteryId 
 * @returns 
 */
export async function getGameVideoResult(videoId,chapterId,lotteryId) {
    return http.post(api.getGameVideoResult,{
    video_ids: videoId,
    chapter_ids: chapterId,
    lottery_id: lotteryId
    })
}

export async function getGametimes(lotteryId) {
    return http.get(api.getGametimes, {
        lottery_id: lotteryId
    })
}